import {useEffect, useState} from "react";
import Tooltip from "components/tooltips/Tooltips";
import {CopyIcon} from "../../assets/icons";
import useReplayableAnimation from "hooks/useReplayableAnimation";
import {toast} from "react-toastify";

const COPIED_POP_CLASS = 'motion-safe:animate-pressPop';

// `toastText`: also said in a toast once copied (« E-mail copié »).
const CopyToClipboard = ({text, showIcon, children, tooltipText, toastText}) => {
  const [isCopied, setIsCopied] = useState(false);
  const defaultTooltipText = tooltipText || 'Copier';
  const textPop = useReplayableAnimation(COPIED_POP_CLASS);
  const iconPop = useReplayableAnimation(COPIED_POP_CLASS);

  const copyToClipboard = (onCopied) => {
    navigator.clipboard.writeText(text).then(r => {
      setIsCopied(true);
      if (toastText) toast.success(toastText);
      onCopied();
    });
  };

  useEffect(() => {
    if (isCopied) {
      setTimeout(() => {
        setIsCopied(false);
      }, 2000);
    }
  }, [isCopied]);

  return (
    <div className="flex">
      <div className={'my-auto truncate cursor-pointer'} onClick={(e) => {
        e.preventDefault()
        e.stopPropagation()
        copyToClipboard(textPop.play)
      }}>
        <Tooltip
          text={isCopied ? 'Copié !' : defaultTooltipText}
          placement="right"
        >
          <div
            className={`hover:underline decoration-dashed ${textPop.animationClassName}`}
            onAnimationEnd={textPop.onAnimationEnd}
          >
            {children}
          </div>
        </Tooltip>
      </div>
      {showIcon && (
        <div className={'my-auto flex ml-1'}>
          <Tooltip
            text={isCopied ? 'Copié !' : defaultTooltipText}
            placement="right"
          >
            <button
              onClick={() => copyToClipboard(iconPop.play)}
              className={iconPop.animationClassName}
              onAnimationEnd={iconPop.onAnimationEnd}
            >
              <CopyIcon wh={24}/>
            </button>
          </Tooltip>
        </div>
      )}
    </div>
  );
}

export default CopyToClipboard